// import './assets/main.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';

import vuetify from './plugins/vuetify'; // Import from the new file
// import 'prismjs'
// import 'prismjs/themes/prism.css'
// import 'prismjs/themes/prism-dark.css'
import * as Sentry from "@sentry/vue";


const app = createApp(App);

Sentry.init({
  app,
  dsn: "https://875bda18e1cea394c8a420337d77642d@o360075.ingest.us.sentry.io/4508738559475712",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

app.use(createPinia());
app.use(router);
app.use(vuetify);

app.mount('#app');
